<template>
    <div class="mjoinus">
        <div class="mj-test">
            <Emoticon :size="50" fillColor="#ffffff"/>
            <span>준비중입니다<br>곧 돌아오겠습니다</span>
        </div>
    </div>
</template>
<script>
import Emoticon from "vue-material-design-icons/Emoticon"
export default {
    name: "MJoinUs",
    components : {
        Emoticon
    }
}
</script>
<style lang="scss" scoped>
.mjoinus {
    width: 100%;
    height: 100%;
    background-color: #97b9b2;
    position: relative;
    .mj-test {
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translateX(-50%) translateY(-50%);
        display: flex;
        flex-direction: column;
        align-items: center;
        span {
            font-size: 18px;
            color: #ffffff;
            margin-top: 10px;
            text-align: center;
            line-height: 25px;
        }
    }
}
</style>